import { render } from "./AvatarBubble.vue?vue&type=template&id=4576b5e0"
import script from "./AvatarBubble.vue?vue&type=script&lang=js"
export * from "./AvatarBubble.vue?vue&type=script&lang=js"

import "./AvatarBubble.vue?vue&type=style&index=0&id=4576b5e0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__